import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { JackBaseComponentModule } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { PageKind, entityState, UiModeType, } from 'jk-service';
import { MtrwfService, templateUrlConfigMtr } from '../_service_mtr';
import { MtrwfEditComponent, } from '../_edit_mtr';
import { jkSingleComponent, JkaggridComponent } from 'jk-advcom';


@Component({
  selector: 'app-mtrpi01',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    JkaggridComponent,
  ],
  templateUrl: './mtrpi01Pkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Mtrpi01Component extends jkSingleComponent implements OnInit {
  override _programId = 'mtrpi01';
  constructor() {
    super();
    this.srv = new MtrwfService();
    this.uiMode = UiModeType.dialog;
    this.title = '網址建立作業';
    this.gridInitOpt = { programId: this.programId, sortField: 'WF001', sort: 'asc', defaultSort: null, pageKind: this.pageKind };
    this.qbeConfig.addField = '';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = MtrwfEditComponent;


    this.constructorInit();
  }

  override agRowClicked(row: any): void {
    if (row && row.WF005) {
      this.router.navigate(['/mtr/mtrpi01/view', row.WF001]);
    }
  }



}
